// Measurement field names
export const FIELD_WIDTH = "width";
export const FIELD_HEIGHT = "height";
export const FIELD_WINDOW_PRODUCT_SIZE_ID = "window_product_size_id";

// Tab names
export const TAB_MEASUREMENTS = "measurements";
export const TAB_SIZES = "sizes";
export const TAB_GRID = "grid";
export const TAB_OBSCURITY = "obscurity";
export const TAB_BLINDS = "blinds";
export const TAB_JOB_PHOTOS = "job_photos";

// Measurement-related tabs (used for validation switching)
export const MEASUREMENT_TABS = [TAB_MEASUREMENTS, TAB_SIZES];

// Measurement field names (used for validation)
export const MEASUREMENT_FIELDS = [
  FIELD_WIDTH,
  FIELD_HEIGHT,
  FIELD_WINDOW_PRODUCT_SIZE_ID,
];
